// extracted by mini-css-extract-plugin
export default {"mobileSpacing":"leaderboard_mobileSpacing__H4biy","cell":"leaderboard_cell__jHqEa","showAll":"leaderboard_showAll__d1JF2","tableContainer":"leaderboard_tableContainer__7TIY1"};